import {
  MUTATION_RESPONSE_RECEIVED,
  MUTATION_REQUEST_SENT,
  MUTATION_REQUIRED,
} from '@web-platform/shared-universal-constants/src/network';
import { objectSome } from '@web-platform/shared-universal-utils-frontend/src/helpers/helpers';

import { getKey } from '../getKey';

import type { MutationType } from '@web-platform/shared-universal-types/src/network/requestTypes';
import type { Variables } from '@web-platform/shared-universal-types/src/network/types';
import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type {
  MutationState,
  MutationItem,
} from '@web-platform/shared-universal-types/src/redux/state/network/mutations';
import type { ID } from '@web-platform/shared-universal-types-utils/src/utils';

// FIXME: SHIBA-809 Bad typecasting - do not copy this pattern
function item<TItem extends MutationItem>(
  action: Action,
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  state: TItem = {} as TItem,
  id: ID = '',
): TItem {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED:
      return {
        ...state,
        complete: true,
        inFlight: false,
        responseAt: action.payload.now,
        response: action.payload.response,
      };

    case MUTATION_REQUEST_SENT:
      return { ...state, inFlight: true };

    case MUTATION_REQUIRED:
      return {
        ...state,
        id,
        type: action.payload.type,
        variables: action.payload.variables,
        request: action.payload.request,
        complete: false,
        inFlight: false,
        responseAt: null,
        response: null,
        createdAt: action.payload.now,
      };

    default:
      return state;
  }
}

function getHasNew(state: MutationState, type: MutationType, variables: Variables) {
  const desiredKey = getKey(type, variables);
  return objectSome(
    state,
    (value: MutationItem) => getKey(value.type, value.variables) === desiredKey && !value.complete,
  );
}

export default function (state: MutationState = {}, action: Action): MutationState {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED:
    case MUTATION_REQUEST_SENT:
      return { ...state, [action.payload.id]: item(action, state[action.payload.id]) };

    case MUTATION_REQUIRED: {
      if (
        action.payload.options &&
        action.payload.options.dedupe &&
        getHasNew(state, action.payload.type, action.payload.variables)
      ) {
        return state;
      }

      const id = `k${Object.keys(state).length}`;
      return { ...state, [id]: item(action, state[id], id) };
    }

    default:
      return state;
  }
}
export const getAll = (state: MutationState): MutationState => state;
